// funcity - A functional language interpreter with text processing
// Copyright (c) Kouji Matsui (@kekyo@mi.kekyo.net)
// Under MIT.
// https://github.com/kekyo/funcity/

export const DEFAULT_SCRIPT = `Hello {{concat 'fun' 'city'}} World!!`;
